function addHandlerToMap(map, eventName, handler) {
    let handlers = map[eventName];
    if (!handlers) {
        handlers = [];
        map[eventName] = handlers;
    }
    handlers.push(handler);
}

function runHandlers(map, eventName, params) {
    const handlers = map[eventName];
    if (handlers) {
        handlers.forEach((handler) => {
            handler(...params);
        });
    }
    return handlers;
}

export default class Evented {
    constructor() {
        this.eventToHandlersMap = {};
        this.onceEventToHandlersMap = {};
    }

    fire(eventName, ...params) {
        runHandlers(this.eventToHandlersMap, eventName, params);
        if (runHandlers(this.onceEventToHandlersMap, eventName, params)) {
            delete this.onceEventToHandlersMap[eventName];
        }
    }

    on(eventName, handler) {
        addHandlerToMap(this.eventToHandlersMap, eventName, handler);
    }

    off(eventName) {
        if (eventName) {
            delete this.eventToHandlersMap[eventName];
            delete this.onceEventToHandlersMap[eventName];
        } else {
            this.eventToHandlersMap = {};
            this.onceEventToHandlersMap = {};
        }
    }

    once(eventName, handler) {
        addHandlerToMap(this.onceEventToHandlersMap, eventName, handler);
    }
}



// WEBPACK FOOTER //
// ./services/evented.js